import { getElementByKey } from '../../../FormRenderer/utils/getElementByKey'

export const handleElementSelection = (
  event: React.MouseEvent,
  showPanel = false,
  xpath: string,
  currentSpec: any,
  setSelectedElement?: (value: any) => void,
  setSelectedPath?: (value: any) => void,
  setShow?: React.Dispatch<React.SetStateAction<boolean>>
) => {
  event.stopPropagation()
  const element = getElementByKey(currentSpec ?? [], xpath)

  if (element != null) {
    setSelectedElement?.(element)
    setSelectedPath?.(xpath)

    if (showPanel) {
      setShow?.(true)
    }
  }
}
